<template>
  <div class="home">
    <ProductList v-show="listView" @newProduct="onClickNewFromList" @editProduct="onClickEditFromList" :scroll="corY" :idx="idx" @resetIndex="resetIndex" ref="refreshList"/>
    <ProductForm v-show="formView" :product="product" @backClicked="onBackChild" @backSaveClicked="onBackSaveChild" @backID="backID" />
  </div>
</template>

<script>
// @ is an alias to /src
import ProductList from '@/components/product/ProductList.vue'
import ProductForm from '@/components/product/ProductForm.vue'
import { mapState } from 'vuex'
import { getHeader, productUrl } from '../config'
import Axios from 'axios'

export default {
  name: 'Product',
  components: {
    ProductList,
    ProductForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      idx: null,
      listView: true,
      formView: false,
      productCategory: [],
      vendors: [],
      product: {
        id: null,
        product_no: null,
        product_sku: null,
        product_name: null,
        product_description: null,
        barcode: null,
        canBarcode: null,
        uom_id: null,
        uoms: [{
          id: null,
          product_no: null,
          uom_id: null,
          ratio: 0,
          active: true,
          category_id: null
        }],
        category_id: null,
        category: null,
        type_id: null,
        price: 0,
        cost: 0,
        costing_method: null,
        costing_evaluation: null,
        onHandQty: 0,
        is_variant: false,
        qty_total: 0,
        company_no: null,
        onHand: [{
          id: null,
          product_no: null,
          product_sku: null,
          qty: null,
          price: null,
          on_hand_date: null,
          notes: null,
          warehouse_no: null,
          branch_no: null,
          uom_id: null,
          adjust_no: null,
          serial_number: null,
          sec_serial_number: null,
          internal_no: null
        }],
        productPurchasing: [{
          id: null,
          product_no: null,
          product_sku: null,
          vendor_no: null,
          vendor: null,
          minimum_quantity: null,
          amount: null,
          start_date: null,
          end_date: null
        }],
        priceList: [{
          group_id: null,
          group: null,
          product_no: null,
          product_sku: null,
          quantity: null,
          price: null,
          uom_id: null,
          start_date: null,
          end_date: null
        }],
        barcodes: [{
          id: null,
          product_no: null,
          product_sku: null,
          barcode: null,
          vendor_no: null,
          vendor: null
        }],
        accounts: [{
          id: null,
          product_no: null,
          product_sku: null,
          account_code: null,
          account: [{
            id: null,
            account_code: null,
            type_code: null,
            account_name: null,
            notes: null,
            account_balance: null,
            group_id: null,
            method: null
          }],
          description: null,
          type_id: null,
          company_no: null
        }],
        costs: [{
          id: null,
          product_no: null,
          product_sku: null,
          ref_no: null,
          cost_amount: '0',
          cost_qty: '0',
          cost_average: '0',
          cost_date: null,
          uom_id: null,
          status: null,
          queue: '0',
          company_no: null,
          type: null
        }],
        variants: [{
          id: null,
          product_no: null,
          product_sku: null,
          name: null,
          variant_id: null,
          variant: null,
          uom_id: null,
          price: null,
          warehouse_no: null,
          branch_no: null,
          serial_number: null
        }],
        photo: null,
        photos: [{
          id: null,
          product_no: null,
          product_sku: null,
          filename: null,
          mime_type: null,
          extension: null,
          type: null
        }],
        packages: [{
          id: null,
          product_id: null,
          product_no: null,
          name: null,
          price: null,
          valid_date: null,
          qty: null,
          product_sku: null,
          serial_number: null,
          uom_id: null
        }]
      }
    }
  },
  methods: {
    resetIndex () {
      this.idx = null
    },
    async backID (id) {
      await Axios.get(productUrl + '/' + id, { headers: getHeader() })
        .then(response => {
          var data = {
            data: response.data.data,
            index: this.index
          }
          this.onClickEditFromList(data)
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error!!!',
            '<pre>' + error.response.data.message + '</pre>',
            'error'
          )
        })
    },
    onClickEditFromList: function (value) {
      var x = 0
      var y = window.scrollY || window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      console.log(x + '|' + y)
      this.listView = false
      this.formView = true
      this.idx = value.index
      this.product = value.data
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      console.log(x + '|' + y)
      this.listView = false
      this.formView = true
      console.log(this.authUser)
      this.product = {
        id: null,
        product_no: null,
        product_name: null,
        product_description: null,
        barcode: null,
        canBarcode: null,
        uom_id: 'pcs',
        uoms: [],
        category_id: null,
        category: null,
        type_id: null,
        price: null,
        cost: null,
        costing_method: 'First In First Out(FIFO)',
        costing_evaluation: 'Automatic',
        onHandQty: 0,
        is_variant: false,
        qty_total: 0,
        company_no: this.authUser.company_no,
        onHand: [{
          id: null,
          product_no: null,
          product_sku: null,
          qty: null,
          price: null,
          on_hand_date: null,
          notes: null,
          warehouse_no: null,
          branch_no: null,
          uom_id: null,
          adjust_no: null,
          serial_number: null,
          sec_serial_number: null,
          internal_no: null
        }],
        productPurchasing: [{
          id: null,
          product_no: null,
          vendor_no: null,
          minimum_quantity: null,
          amount: null,
          start_date: null,
          end_date: null
        }],
        priceList: [{
          id: null,
          group_id: null,
          group: null,
          product_no: null,
          quantity: null,
          price: null,
          uom_id: null,
          start_date: null,
          end_date: null
        }],
        barcodes: [{
          id: null,
          product_no: null,
          barcode: null,
          vendor_no: null,
          vendor: null
        }],
        accounts: [{
          id: null,
          product_no: null,
          account_code: null,
          account: [{
            id: null,
            account_code: null,
            type_code: null,
            account_name: null,
            notes: null,
            account_balance: null,
            group_id: null,
            method: null
          }],
          description: null,
          type_id: null,
          company_no: null
        }],
        costs: [{
          id: null,
          product_no: null,
          product_sku: null,
          ref_no: null,
          cost_amount: '0',
          cost_qty: '0',
          cost_average: '0',
          cost_date: null,
          uom_id: null,
          status: null,
          queue: '0',
          company_no: null,
          type: null
        }],
        variants: [{
          id: null,
          product_no: null,
          product_sku: null,
          name: null,
          variant_id: null,
          variant: null,
          uom_id: null,
          warehouse_no: null,
          price: null,
          branch_no: null,
          serial_number: null
        }],
        photo: null,
        photos: [{
          id: null,
          product_no: null,
          product_sku: null,
          filename: null,
          mime_type: null,
          extension: null,
          type: null
        }],
        packages: [{
          product_id: null,
          product_no: null,
          name: null,
          price: null,
          valid_date: null,
          qty: null,
          product_sku: null,
          serial_number: null,
          uom_id: null
        }]
      }
    },
    async onBackChild () {
      this.listView = true
      this.formView = false
      this.product = {
        id: null,
        product_no: null,
        product_name: null,
        product_description: null,
        barcode: null,
        canBarcode: null,
        uom_id: null,
        uoms: [],
        category_id: null,
        category: null,
        type_id: null,
        price: 0,
        cost: 0,
        costing_method: null,
        costing_evaluation: null,
        onHandQty: 0,
        is_variant: false,
        qty_total: 0,
        company_no: null,
        onHand: [{
          id: null,
          product_no: null,
          product_sku: null,
          qty: null,
          price: null,
          on_hand_date: null,
          notes: null,
          warehouse_no: null,
          branch_no: null,
          uom_id: null,
          adjust_no: null,
          serial_number: null,
          sec_serial_number: null,
          internal_no: null
        }],
        productPurchasing: [{
          id: null,
          product_no: null,
          vendor_no: null,
          minimum_quantity: null,
          amount: null,
          start_date: null,
          end_date: null
        }],
        priceList: [{
          group_id: null,
          group: null,
          product_no: null,
          quantity: null,
          price: null,
          uom_id: null,
          start_date: null,
          end_date: null
        }],
        barcodes: [{
          id: null,
          product_no: null,
          barcode: null,
          vendor_no: null,
          vendor: null
        }],
        accounts: [{
          id: null,
          product_no: null,
          account_code: null,
          account: [{
            id: null,
            account_code: null,
            type_code: null,
            account_name: null,
            notes: null,
            account_balance: null,
            group_id: null,
            method: null
          }],
          description: null,
          type_id: null,
          company_no: null
        }],
        costs: [{
          id: null,
          product_no: null,
          product_sku: null,
          ref_no: null,
          cost_amount: '0',
          cost_qty: '0',
          cost_average: '0',
          cost_date: null,
          uom_id: null,
          status: null,
          queue: '0',
          company_no: null,
          type: null
        }],
        variants: [{
          id: null,
          product_no: null,
          product_sku: null,
          name: null,
          variant_id: null,
          variant: null,
          uom_id: null,
          warehouse_no: null,
          branch_no: null,
          price: null,
          serial_number: null
        }],
        photo: null,
        photos: [{
          id: null,
          product_no: null,
          product_sku: null,
          filename: null,
          mime_type: null,
          extension: null,
          type: null
        }],
        packages: [{
          id: null,
          product_id: null,
          product_no: null,
          name: null,
          price: null,
          valid_date: null,
          qty: null,
          product_sku: null,
          serial_number: null,
          uom_id: null
        }]
      }
      await this.$refs.refreshList.refreshProduct()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    },
    async onBackSaveChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.product = {
        id: null,
        product_no: null,
        product_name: null,
        product_description: null,
        barcode: null,
        canBarcode: null,
        uom_id: null,
        uoms: [{
          id: null,
          product_no: null,
          uom_id: 'pcs',
          ratio: 0,
          active: true,
          category_id: null
        }],
        category_id: null,
        category: null,
        type_id: null,
        price: 0,
        cost: 0,
        costing_method: null,
        costing_evaluation: null,
        onHandQty: 0,
        is_variant: false,
        qty_total: 0,
        company_no: null,
        onHand: [{
          id: null,
          product_no: null,
          product_sku: null,
          qty: null,
          price: null,
          on_hand_date: null,
          notes: null,
          warehouse_no: null,
          branch_no: null,
          uom_id: null,
          adjust_no: null,
          serial_number: null,
          sec_serial_number: null,
          internal_no: null
        }],
        productPurchasing: [{
          id: null,
          product_no: null,
          vendor_no: null,
          minimum_quantity: null,
          amount: null,
          start_date: null,
          end_date: null
        }],
        priceList: [{
          group_id: null,
          group: null,
          product_no: null,
          quantity: null,
          price: null,
          uom_id: null,
          start_date: null,
          end_date: null
        }],
        barcodes: [{
          id: null,
          product_no: null,
          barcode: null,
          vendor_no: null,
          vendor: null
        }],
        accounts: [{
          id: null,
          product_no: null,
          account_code: null,
          account: [{
            id: null,
            account_code: null,
            type_code: null,
            account_name: null,
            notes: null,
            account_balance: null,
            group_id: null,
            method: null
          }],
          description: null,
          type_id: null,
          company_no: null
        }],
        costs: [{
          id: null,
          product_no: null,
          product_sku: null,
          ref_no: null,
          cost_amount: '0',
          cost_qty: '0',
          cost_average: '0',
          cost_date: null,
          uom_id: null,
          status: null,
          queue: '0',
          company_no: null,
          type: null
        }],
        variants: [{
          id: null,
          product_no: null,
          product_sku: null,
          name: null,
          variant_id: null,
          variant: null,
          uom_id: null,
          warehouse_no: null,
          branch_no: null,
          price: null,
          serial_number: null
        }],
        photo: null,
        photos: [{
          id: null,
          product_no: null,
          product_sku: null,
          filename: null,
          mime_type: null,
          extension: null,
          type: null
        }],
        packages: [{
          id: null,
          product_id: null,
          product_no: null,
          name: null,
          price: null,
          valid_date: null,
          qty: null,
          product_sku: null,
          serial_number: null,
          uom_id: null
        }]
      }
      await this.$refs.refreshList.refreshProduct()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser
    })
  },
  mounted () {
    this.$store.dispatch('getUomList')
    this.$store.dispatch('getUomCategoryList')
    this.$store.dispatch('getProductCategoryList')
    this.$store.dispatch('getProductTypeList')
    this.$store.dispatch('getVendorList')
    this.$store.dispatch('getPriceListGroup')
    this.$store.dispatch('getRowTable')
    this.$store.dispatch('getWarehouseList')
    this.$store.dispatch('getAccountList')
    this.$store.dispatch('getProductAccountTypeLst')
    this.$store.dispatch('getVariantList')
    this.$store.dispatch('getCompanyList')
  }
}
</script>
